import type { TrackingPixels } from '../../lib/api/operatorConsole';

const CONSENT_TEXT =
  'We confirm that our players have consented to advertising tracking where the law requires it, and that our privacy policy covers these pixels. What they collect goes to our own ad accounts.';

type Props = {
  consent: TrackingPixels['consent'];
  ticked: boolean;
  onChange: (ticked: boolean) => void;
};

export function ConsentField({ consent, ticked, onChange }: Props) {
  if (consent) {
    return (
      <p className="text-[12px] text-[var(--co-muted)]">
        Consent confirmed by {consent.accepted_by} on {new Date(consent.accepted_at).toLocaleDateString()}.
      </p>
    );
  }
  return (
    <label className="flex items-start gap-2 text-[12px] text-[var(--co-text)]">
      <input
        type="checkbox"
        checked={ticked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5"
      />
      <span>{CONSENT_TEXT}</span>
    </label>
  );
}
